import React from 'react'
import { ChapterLinkTrack, ChapterLinkScenario, ChapterLinkPoint } from './link'
import BookResource from './resource'

export default ({ action, chapters }) => {
  // Action vide ({} ou sans type) : on n'affiche rien.
  if (!action || !action.type) {
    return null
  }

  const experienceChapter = Object.values(chapters).find(({ type }) => type === 'experience')
  const experience = (experienceChapter || {}).experience
  const { timers } = experience || {}

  const pointName = pointId => {
    const point = (chapters[pointId] || {}).point || {}
    return ' ' + (point.name || point.internalName || '')
  }
  const timerName = timerId => (timers && timers[timerId] && timers[timerId].name) || ''

  let icon = 'fa-bolt'
  let content

  switch (action.type) {
    // Navigation
    case 'load_track':
      icon = 'fa-map-signs'
      content = (
        <>
          Lancer le parcours <ChapterLinkTrack trackId={action.track} chapters={chapters} />
        </>
      )
      break
    case 'load_scenario':
      icon = 'fa-play-circle'
      content = (
        <>
          Lancer le scénario <ChapterLinkScenario scenarioId={action.scenario} chapters={chapters} />
        </>
      )
      break
    case 'load_module':
      icon = 'fa-exchange'
      content = 'Changer de module'
      break
    case 'end_module':
      icon = 'fa-check'
      content = 'Terminer le module'
      break

    // État des points
    case 'check_point':
      icon = 'fa-check'
      content = (
        <>
          « Check » du point <ChapterLinkPoint pointId={action.point} chapters={chapters} text={pointName(action.point)} />
        </>
      )
      break
    case 'uncheck_point':
      icon = 'fa-undo'
      content = (
        <>
          « Uncheck » du point <ChapterLinkPoint pointId={action.point} chapters={chapters} text={pointName(action.point)} />
        </>
      )
      break
    case 'enable_point':
      icon = 'fa-check-circle'
      content = (
        <>
          Activer le point <ChapterLinkPoint pointId={action.point} chapters={chapters} text={pointName(action.point)} />
        </>
      )
      break
    case 'disable_point':
      icon = 'fa-ban'
      content = (
        <>
          Désactiver le point <ChapterLinkPoint pointId={action.point} chapters={chapters} text={pointName(action.point)} />
        </>
      )
      break
    case 'show_point':
      icon = 'fa-eye'
      content = (
        <>
          Afficher le point <ChapterLinkPoint pointId={action.point} chapters={chapters} text={pointName(action.point)} />
        </>
      )
      break
    case 'hide_point':
      icon = 'fa-eye-slash'
      content = (
        <>
          Masquer le point <ChapterLinkPoint pointId={action.point} chapters={chapters} text={pointName(action.point)} />
        </>
      )
      break
    case 'enable_all_points':
      icon = 'fa-check-circle'
      content = 'Activer tous les points du parcours courant'
      break
    case 'disable_all_points':
      icon = 'fa-ban'
      content = 'Désactiver tous les points du parcours courant'
      break
    case 'show_all_points':
      icon = 'fa-eye'
      content = 'Afficher tous les points du parcours courant'
      break
    case 'hide_all_points':
      icon = 'fa-eye-slash'
      content = 'Masquer tous les points du parcours courant'
      break

    // Actions diverses en jeu
    case 'add_score':
      icon = 'fa-trophy'
      content = `Ajouter ${action.score} points`
      break
    case 'play_sound':
      icon = 'fa-volume-up'
      content = (
        <>
          Lire le son <BookResource id={action.sound} />
        </>
      )
      break
    case 'show_popup':
      icon = 'fa-comment'
      content = 'Afficher un popup'
      break
    case 'toggle_torch':
      icon = 'fa-lightbulb-o'
      content = 'Allumer / éteindre la lampe torche'
      break
    case 'stop_session':
      icon = 'fa-stop-circle'
      content = 'Terminer la partie'
      break
    case 'end_session':
      icon = 'fa-sign-out'
      content = 'Terminer et quitter la partie'
      break

    // Gestion du temps
    case 'start_timer':
      icon = 'fa-hourglass-start'
      content = `Démarrer le compte à rebours ${timerName(action.timer)}`
      break
    case 'stop_timer':
      icon = 'fa-hourglass-end'
      content = `Arrêter le compte à rebours ${timerName(action.timer)}`
      break
    case 'stop_all_timers':
      icon = 'fa-clock-o'
      content = 'Arrêter tous les comptes à rebours'
      break
    case 'start_game_timer':
      icon = 'fa-hourglass-start'
      content = 'Démarrer le chronomètre'
      break
    case 'stop_game_timer':
      icon = 'fa-hourglass-end'
      content = 'Arrêter le chronomètre'
      break
    case 'reset_game_timer':
      icon = 'fa-refresh'
      content = 'Réinitialiser le chronomètre'
      break

    // Éléments du parcours
    case 'show_menu':
      icon = 'fa-bars'
      content = 'Afficher un élément du menu'
      break
    case 'hide_menu':
      icon = 'fa-bars'
      content = 'Masquer un élément du menu'
      break
    case 'show_map':
      icon = 'fa-map'
      content = 'Afficher une carto'
      break
    case 'hide_map':
      icon = 'fa-map'
      content = 'Masquer une carto'
      break

    // Switch
    case 'add_switch':
      icon = 'fa-random'
      content = (
        <>
          Définir le switch <code>{action.key}</code>
          {action.value != null && action.value !== '' ? (
            <>
              {' = '}
              <code>{String(action.value)}</code>
            </>
          ) : null}
        </>
      )
      break
    case 'delete_switch':
      icon = 'fa-random'
      content = (
        <>
          Supprimer le switch <code>{action.key}</code>
        </>
      )
      break

    // Bluetooth
    case 'connect_ble':
      icon = 'fa-bluetooth-b'
      content = (
        <>
          Activer la connexion bluetooth
          {action.network ? (
            <>
              {' '}
              (<code>{action.network}</code>)
            </>
          ) : null}
        </>
      )
      break
    case 'disconnect_ble':
      icon = 'fa-bluetooth-b'
      content = 'Désactiver la connexion bluetooth'
      break
    case 'send_ble':
      icon = 'fa-bluetooth-b'
      content = (
        <>
          Envoyer en bluetooth <code>{action.message}</code>
        </>
      )
      break

    default:
      icon = 'fa-question-circle'
      content = <span className="book-action-unknown">Action non gérée : {action.type || '?'}</span>
  }

  return (
    <span className="book-action">
      <i className={'fa ' + icon} />
      <span>{content}</span>
    </span>
  )
}
